<div class="container mb-4">
  <div class="row">
    <div class="col-12 return-view-header-actions">
      <div class="header-slot header-slot-left">
        <button
          *ngIf="isPostSubMode"
          type="button"
          class="btn btn-sm backBtn"
          (click)="goBackToTaxAndPayment()">
          <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left arrowBack"
            fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
          </svg>&nbsp;Back
        </button>
      </div>

      <div class="header-slot header-slot-center">
        <div class="return-view-toggle" *ngIf="isShow && !isProduction">
          <button
            type="button"
            class="btn btn-sm view-toggle-btn"
            [class.active]="!showDetailsReturn"
            [disabled]="isViewSwitching"
            (click)="closeDetailsReturn()">
            <i class="fa fa-spinner fa-spin" *ngIf="pendingDetailsView === false" aria-hidden="true"></i>
            Short View
          </button>
          <button
            type="button"
            class="btn btn-sm view-toggle-btn"
            [class.active]="showDetailsReturn"
            [disabled]="isViewSwitching"
            (click)="getReturnDetailsData()">
            <i class="fa fa-spinner fa-spin" *ngIf="pendingDetailsView === true || isLoadingDetailsReturn"
              aria-hidden="true"></i>
            Detail View
          </button>
        </div>
      </div>

      <div class="header-slot header-slot-right">
        <div class="d-flex justify-content-end" *ngIf="isShow">
          <button
            type="button"
            class="btn btn-sm"
            [ngClass]="{ activeLangBtn: currentLang === 'en', inactiveLangBtn: currentLang === 'bn' }"
            (click)="setLanguage('en')">
            English
          </button>
          <button
            type="button"
            class="btn btn-sm"
            [ngClass]="{ activeLangBtn: currentLang === 'bn', inactiveLangBtn: currentLang === 'en' }"
            (click)="setLanguage('bn')">
            Bangla
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isShow">
  <div class="view-switch-wrapper">
    <div class="view-switch-overlay" *ngIf="isViewSwitching">
      <div class="view-switch-box">
        <div class="view-switch-spinner"></div>
        <span class="view-switch-label">
          {{ pendingDetailsView === false ? 'Loading short view...' : 'Loading details view...' }}
        </span>
      </div>
    </div>

    <app-return-view-content
      class="view-switch-content"
      [class.is-switching]="isViewSwitching"
      [returnData]="apiData"
      [currentLang]="currentLang"
      [printActive]="printActive"
      [showDraftWatermark]="isPostSubMode"
      [showDetailsReturn]="showDetailsReturn"
      [returnDetailsData]="detailsViewData"
      printSectionId="print_final_return_view">
    </app-return-view-content>
  </div>

  <div class="container py-5" *ngIf="isPostSubMode">
    <div class="row d-flex justify-content-between">
      <button type="button" class="btn btn-sm backBtn" (click)="goBackToTaxAndPayment()">
        <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left arrowBack"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
        </svg>&nbsp;Back
      </button>
      <button
        type="button"
        class="btn btn-sm saveContinueBtn return-submit-btn"
        (click)="proceedToSubmission()">
        <i class="fa fa-paper-plane" aria-hidden="true"></i>
        Submit Return
      </button>
    </div>
  </div>

  <div *ngIf="isFinalMode">
    <div class="container my-3" hidden="true">
      <div class="row">
        <div class="col-12">
          <button
            type="button"
            #print
            class="btn btn-sm bg-white btn-pill rounded-pill btn-outline-dark btn-customize print-btn-hidden"
            [printStyle]="{ body: { background: 'white' } }"
            [useExistingCss]="true"
            printTitle="Return-{{ userTin }}"
            printSectionId="print_final_return_view"
            ngxPrint>
            <i class="fa fa-print mr-1" aria-hidden="true"></i><b>Print</b>
          </button>
        </div>
      </div>
    </div>

    <div class="container my-3">
      <div class="row">
        <div class="col-12">
          <button type="button" class="btn btn-sm bg-white btn-pill rounded-pill btn-outline-dark btn-customize print-btn"
            (click)="triggerPrint()">
            <i class="fa fa-print mr-1" aria-hidden="true"></i><b>Print</b>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="return-view-page-loader" *ngIf="!isShow">
  <div class="view-switch-spinner"></div>
  <span class="view-switch-label">Loading Return View</span>
</div>

<ng-template #returnSubmissionPopup>
  <div class="modal-header">
    <h4 class="modal-title pull-left warning-title">Warning</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeSubmissionModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!isUserTRP">
    <p>Do you want to submit return?</p>
    <button type="button" class="btn btn-success modal-action-btn" (click)="confirmSubmission()">Yes</button>
    <button type="button" class="btn btn-danger modal-action-btn modal-action-btn--spaced" (click)="closeSubmissionModal()">No</button>
  </div>

  <div class="modal-body" *ngIf="isUserTRP">
    <p>Do you want to submit taxpayer's return?</p>
    <button type="button" class="btn btn-success modal-action-btn" (click)="startTrpSubmission(trpReturnSubmissionPopup)">Yes</button>
    <button type="button" class="btn btn-danger modal-action-btn modal-action-btn--spaced" (click)="closeSubmissionModal()">No</button>
  </div>
</ng-template>

<ng-template #trpReturnSubmissionPopup>
  <div class="modal-header">
    <h4 class="modal-title pull-left">TRP Return Submission</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancelTrpSubmission()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="otpForm" (ngSubmit)="submitReturnWithOtp()">
      <label>OTP has been shared with Taxpayer's phone number. Please Enter the 6 Digit OTP below.</label>

      <div class="row justify-content-center my-3">
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            formControlName="otpValue"
            maxlength="6"
            [ngClass]="{
              'is-invalid': (otpControls.otpValue.dirty || otpControls.otpValue.touched) && otpControls.otpValue.invalid,
              'is-valid': otpControls.otpValue.touched && !otpControls.otpValue.errors
            }" />

          <div *ngIf="(otpControls.otpValue.touched || otpControls.otpValue.dirty) && otpControls.otpValue.invalid"
            class="text-danger">
            <div *ngIf="otpControls.otpValue.errors?.required">OTP value is required</div>
            <div *ngIf="otpControls.otpValue.errors?.pattern">OTP value must be exactly 6 digits</div>
          </div>
        </div>
      </div>

      <div class="my-2">
        <button type="submit" class="btn btn-success modal-action-btn" [disabled]="otpControls.otpValue.invalid">Yes</button>
        <button type="button" class="btn btn-danger modal-action-btn modal-action-btn--spaced" (click)="cancelTrpSubmission()">No</button>
      </div>
    </form>
  </div>
</ng-template>
